import { render } from "./ImdSelectArea.vue?vue&type=template&id=25879af4&scoped=true"
import script from "./ImdSelectArea.vue?vue&type=script&lang=js"
export * from "./ImdSelectArea.vue?vue&type=script&lang=js"

import "./ImdSelectArea.vue?vue&type=style&index=0&id=25879af4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25879af4"]])

export default __exports__